// if desktop, when window is resized refresh the page to recalculate positions

if($(window).width() > 720){ 
  $(window).bind('resize', function(e)
  {
    if (window.RT) clearTimeout(window.RT);
    window.RT = setTimeout(function()
    {
      this.location.reload(false); /* false to get page from cache */
    }, 100);
  });

}

  // calculate height of thumbs and container to position
  var mainImagesHeight = $('.mainImage-container').height();
  var thumbsHeight = $('#thumbs').height();
  var position = mainImagesHeight - thumbsHeight;


  /* Product image scroll ----------------*/
  function productScroll() {

    //mobile 
    if($(window).width() < 720){  
      $('.inview-stop').off('inview');
      //$("#thumbs").css("top", position - 5);  
      // $('.product-info').removeClass('info-unstick');
    } 
    // desktop
    else{

        // change thumbs from fixed to absolute when reach bottom
        $('.inview-stop').bind('inview', function (event, visible) {
            if (visible == true){
              $('#thumbs').addClass('thumbs-unstick'); 
              $("#thumbs").css("top", position - 70); 
              $('#thumb-scroll').addClass('thumbs-unstick');         
              // $('.product-info').addClass('info-unstick');
            } 
            else {
              $('#thumbs').removeClass('thumbs-unstick');
               $("#thumbs").css("top", "95");      
              // $('.product-info').removeClass('info-unstick');
            }
        });

    }
  }

  var mobile_images_initial_html = "";

  function loadMobileImages(){

    if($(window).width() < 720){  

      mobile_images_initial_html = $("#mobile-product-images").html();
      initCarousel();
      //$('#mobile-product-images').show();

     } else{
      $('#mobile-product-images').hide();
     }
    
  }

  function initCarousel() {
    $("#mobile-product-images").owlCarousel({
        navigation : false, // Show next and prev buttons
        slideSpeed : 300,
        paginationSpeed : 400,
        singleItem:true,
        pagination: true,
        transitionStyle : "fade",
        lazyLoad : true,
        afterInit: function(){
         $('#mobile-product-images').show();
        }
    });
  }

 
  function loadMobileImagesResponsive(){

    
    if($(window).width() < 720){  

      $('#mobile-product-images').css({ 'display': 'block' });
     }
     else{
      $('#mobile-product-images').hide();
     }
    
}
 

function showDescriptionAlertMessages() {

  var alert_message_content = "";

  var selector = ".product-description span > em > strong, .product-description span > strong > em, .product-description em > span > strong, .product-description em > strong > span, .product-description strong > em > span, .product-description strong > span > em";

  for (var i = 0; i < $(selector).length; i++) {
    var _this = $($(selector)[i]);
    if (_this.html() != "") {
      alert_message_content += "<p>"+_this.html()+"</p>";
    }
  };

  $(".product-description").before("<div class='product_alert'>"+alert_message_content+"</div>");

  //console.log(allert_message_content);

}   





// ======================================================================= START Simultaneous scroll 

// this variable is used to determine what element is being scrolled 
var first_scrolled_element = undefined;

// used to determine when scrolling has stopped 
var timer = null;




$(window).scroll(function(e) {
  
  // detect when srolling stopped 
  if(timer !== null) {
      clearTimeout(timer);        
  }
  timer = setTimeout(function() {
    first_scrolled_element = undefined;
  }, 150);


  if ( first_scrolled_element == undefined ) {
    first_scrolled_element = $(this);
  }

  scrollRelatedElement($(".product-info"), $(this));

  whenScrolledToBottom();

});


$(".product-info").scroll(function() {

  if ( first_scrolled_element == undefined ) {
    first_scrolled_element = $(this);
  }

  scrollRelatedElement($(window), $(this));
}); 

// function to scroll one element in sync with the other 
function scrollRelatedElement(element, this_element) {

  // only run when the element being scrolled by a user, not by this function (setting scrollTop)
  // otherwise you runt into an endless loop, as scroll event is fired when element.scrollTop is set 
  if (first_scrolled_element[0] != $(this_element)[0] ) {
    return false
  }

  // record the posisiton at which element stopped scrolling 
  if ( this_element.attr("data-last-scroll-top") == undefined ) {
    this_element.attr("data-last-scroll-top", 0);
    var lastScrollTop = 0;
  } else {
    var lastScrollTop = parseInt(this_element.attr("data-last-scroll-top"));
  }


  // also change data-last-scroll-top of related elements 
  element.attr("data-last-scroll-top", element.scrollTop());

  // detect if a user is scrolling up or down 
  // and scroll the related elements accordingly 
  var st = this_element.scrollTop();
   if (st > lastScrollTop){
       // downscroll code

       var difference = st - lastScrollTop;

       var scroll_element_down = element.scrollTop() + difference;
       element.scrollTop(scroll_element_down);
   } else {
    
      var difference = lastScrollTop - st;

      // upscroll code
       var scroll_element_up = element.scrollTop() - difference;
       element.scrollTop(scroll_element_up);
   }
   lastScrollTop = st;
   this_element.attr("data-last-scroll-top", lastScrollTop);
}

function whenScrolledToBottom() {

  if ($(window).width() > 719) {
    var footer_height = $("footer").outerHeight();
    var scroll_position = $(window).scrollTop() + $(window).height();
    var doc_height = $(document).height();

    if ( scroll_position >= (doc_height - footer_height - 500) ) {

      var difference = scroll_position - (doc_height - footer_height);

      //console.log(difference);

      $(".product-info").css("top", "auto");

      $(".product-info").css("bottom", 500 + difference + "px");


      //console.log("scrolled to bottom");
    } else {
      $(".product-info").css("top", "95px");
      $(".product-info").css("bottom", "auto");
    }
  }


}
// ======================================================================= END Simultaneous scroll 




$(window).resize(function() {
    productScroll();
    loadMobileImagesResponsive();
});

// !important! to do it on $(document).ready
$(document).ready(function(){
  productScroll();
  loadMobileImages();
});

$(document).ready(function(){
  showDescriptionAlertMessages();
});
